<template>
  <div style="overflow: hidden;">
    <headers :title="title"></headers>
    <div class="boxTwo left top20">
      <div class="alltitle">{{title}}</div>
      <div class="allMain">
        <div class="boxData">
          <p>本书房馆藏量</p>
          <p>{{totalcount}}</p>
        </div>
        <div class="operateMain">
          <p>
            本书房总借书量
            <span>{{zwInfo31.totallend}}</span>
          </p>
          <p>
            本书房总还书量
            <span>{{zwInfo31.totalreturn}}</span>
          </p>
          <p>
            本书房总办证量
            <span>{{zwInfo31.totalreader}}</span>
          </p>
          <p>
            本书房今日办证量
            <span>{{zwInfo31.curdayreader}}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="boxThree left top20">
      <div class="alltitle">本馆人次数据</div>
      <div class="allMain">
        <div class="boxData">
          <p>本年度进馆人次</p>
          <p>{{yearInCount}}</p>
        </div>
        <div class="operateMainTwo">
          <p>
            今日进馆人数
            <span>{{todayInCount}}</span>
          </p>
          <p>
            昨日进馆人数
            <span>{{yesterdayCount}}</span>
          </p>
          <p>
            当前在馆人数
            <span>{{inCount}}</span>
          </p>
          <p>
            历史进馆人次
            <span>{{allInCount}}</span>
          </p>
        </div>
      </div>
    </div>
    <div style="clear: both;"></div>
    <div class="contrastBox">
      <div class="alltitle">今日与昨日进馆人数对比</div>
      <div class="echartLine" id="echart-line"></div>
    </div>
    <div class="boxbing left">
      <div class="alltitle">今日与昨日借还书量做对比</div>

      <div class="boxBorder">
        <p>今日借书量</p>
        <span>{{zwInfo31.curdaylend}}</span>
      </div>
      <div class="boxBorder">
        <p>昨日借书量</p>
        <span>{{zwInfo31.lastdaylend}}</span>
      </div>
      <div class="boxBorder">
        <p>今日还书量</p>
        <span>{{zwInfo31.curdayreturn}}</span>
      </div>
      <div class="boxBorder">
        <p>昨日还书量</p>
        <span>{{zwInfo31.lastdayreturn}}</span>
      </div>


    </div>

    <div class="QRcode">
      <div class="QRcodeMain">
        <div class="alltitle">扫码评价</div>
        <img class="qrcodeImg" :src="questionnaireQrcode" alt />
        <div class="tip">微信扫一扫，可以对本书房 进行满意度评价</div>
      </div>
      <div class="ring">
      <process-circle :strokeWidth="strokeWidth" :strokeColor="strokeColor" :trailWidth="trailWidth" :trailColor="trailColor" :percent="satisfyRatio" >
          <p class="ringName">当前满意度</p>
          <p class="ringnum">{{satisfyRatio}}<span>%</span></p>
      </process-circle>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getDayEntityHourData,
    getDayEntityData,
    getEntityYearData,
    getEntityAllYearData
  } from '@/api/anjisheng';
  import {
    formatDate,
    getPreMonth
  } from '@/utils/date.js'
  const echarts = require("echarts");
  import headers from "./headers.vue";
  import {
    getAjsHeaderInfo,
    getZwInfo
  } from "@/api/open";
  import processCircle from "./circle.vue"
  import {getQuestionnaireQrCodeById} from "@/api/study";

  export default {
    components: {
      headers,
      processCircle
    },
    data() {
      return {
        strokeWidth:12, //线条宽度
        strokeColor:'#16D0FF',  //线条颜色
        trailWidth:12, //背景线条宽度
        trailColor:'#DBDBDB',//背景线条宽度
        satisfyRatio:0, //默认情况下是0
        xLineData: [
          '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18',
          '19', '20', '21', '22', '23'
        ],
        yLineDataOne: [
          130,
          200,
          250,
          200,
          150,
          180,
          200,
          250,
          300,
          100,
          150,
          120,
          180,
          240,
          300,
          340,
          350,
          200,
          500,
          400
        ],
        yLineDataTwo: [
          30,
          100,
          150,
          100,
          50,
          80,
          100,
          150,
          200,
          0,
          50,
          20,
          80,
          140,
          200,
          240,
          250,
          100,
          400,
          300
        ],
        zwForm: {
          libcode: null,
          ifcode: null,
          libid: null,
          lendstation: null,
          username: null,
        },
        headerInfo: {},
        libraryInfo: {},
        totalcount: 0,
        zwInfo31: {},
        questionnaireQrcode: null,
        title: "",
        yearInCount: 0,
        todayInCount: 0,
        yesterdayCount: 0,
        inCount: 0,
        allInCount: 0,
      };
    },
    created() {
      this.headerInfo = JSON.parse(sessionStorage.getItem("headerInfo"));
      this.libraryInfo = JSON.parse(sessionStorage.getItem("libraryInfo"));
      this.questionnaireQrcode = sessionStorage.getItem('questionnaireQrcode');
      this.zwForm.libcode = this.headerInfo.libcode;
      this.zwForm.libid = this.libraryInfo.libraryNo;
      // this.zwForm.libid = "103";
      this.getZwInfo24();
      this.getZwInfo31();
      // 获取调查问卷二维码
    },
    mounted() {
      this.timers = setInterval(() => {
        this.getZwInfo24();
        this.getZwInfo31();
        this.getDayEntityHourData()
        this.getQuestionnaireQrCode()
      }, 5 * 60 * 1000);
      this.getDayEntityHourData()
      this.getQuestionnaireQrCode()
      /* var _this = this;
      setTimeout(()=>{
      _this.percent = 90;},100) */
    },
    methods: {
      getQuestionnaireQrCode() {
        var _this = this;
        getQuestionnaireQrCodeById(this.libraryInfo.questionnaireId).then(response=>{
          //this.qrcode = response.data.qrcode;
          console.log('满意',response.data)
          _this.satisfyRatio = response.data.satisfyRatio
          /* if (this.qrcode) {
            sessionStorage.setItem('questionnaireQrcode',this.qrcode);
          } */

        })
      },
      getDayEntityHourData() {
        var libraryInfo = JSON.parse(sessionStorage.getItem("libraryInfo"));

        var _this = this;
        _this.title = libraryInfo.name;
        getDayEntityHourData(libraryInfo.entityId).then(response => {

          _this.yLineDataOne = [];
          for (var i = 0; i < response.Data.length; i++) {
            _this.yLineDataOne.push(response.Data[i].DataIn);
          }
          var yeasDay = formatDate(new Date(new Date().getTime() - 24 * 60 * 60 * 1000), "yyyy-MM-dd");

          getDayEntityHourData(libraryInfo.entityId, yeasDay + " 00:00:00", yeasDay + " 23:59:59").then(
          response => {

            _this.yLineDataTwo = [];
            for (var i = 0; i < response.Data.length; i++) {
              _this.yLineDataTwo.push(response.Data[i].DataIn);
            }
            _this.lineChart()
          })


        })

        getEntityYearData(libraryInfo.entityId).then(response => {

          _this.yearInCount = response.Data[response.Count - 1].DataIn;

        })

        getDayEntityData(libraryInfo.entityId).then(response => {

          _this.todayInCount = response.Data[0].DataIn;
          _this.inCount = response.Data[0].DataIn - response.Data[0].DataOut
          if (_this.inCount<0) {
            _this.inCount=0;
          }

        }).catch(error => {
          console.log(error);
        });


        var yeasDay = formatDate(new Date(new Date().getTime() - 24 * 60 * 60 * 1000), "yyyy-MM-dd");

        getDayEntityData(libraryInfo.entityId, yeasDay + " 00:00:00", yeasDay + " 23:59:59").then(response => {

          _this.yesterdayCount = response.Data[0].DataIn;


        }).catch(error => {
          console.log(error);
        });


        getEntityAllYearData(libraryInfo.entityId).then(response => {

          var allIn = 0;

          for (var i = 0; i < response.Data.length; i++) {
            allIn = allIn + response.Data[i].DataIn
          }
          _this.allInCount = allIn;

        })

      },
      initData() {
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById("main1"));
        // 绘制图表
        myChart.setOption({
          title: {
            x: "center" //x轴方向对齐方式
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          series: [{
            name: "数据分类",
            type: "pie",
            radius: "40%",
            center: ["40%", "40%"],
            data: [{
                value: this.zwInfo31.curdaylend,
                name: "今日",
                itemStyle: {
                  color: "#FAC858"
                }
              },
              {
                value: this.zwInfo31.lastdaylend,
                name: "昨日",
                itemStyle: {
                  color: "#EE6666"
                }
              }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }]
        });
      },
      initDataMain2() {
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById("main2"));
        // 绘制图表
        myChart.setOption({
          title: {
            x: "center" //x轴方向对齐方式
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          series: [{
            name: "数据分类",
            type: "pie",
            radius: "40%",
            center: ["40%", "40%"],
            data: [{
                value: this.zwInfo31.curdayreturn,
                name: "今日"
              },
              {
                value: this.zwInfo31.lastdayreturn,
                name: "昨日"
              }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }]
        });
      },
      lineChart() {
        let getchart = echarts.init(document.getElementById("echart-line"));
        var option = {
          color: ["#80FFA5", "#00DDFF"],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985"
              }
            }
          },
          legend: {
            data: ["本月", "上月"],
            top: 40,
            right: 10,
            textStyle: {
              //图例文字的样式
              color: "#628EDB",
              fontSize: 16
            }
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          dataZoom: [{
            type: "inside",
            start: 0,
            end: 74
          }],
          xAxis: [{
            type: "category",
            boundaryGap: false,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#4E73B4"
              }
            },
            data: this.xLineData
          }],
          yAxis: [{
            type: "value",
            name: "数量",
            splitLine: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#4E73B4"
              }
            }
          }],
          series: [{
              name: "本月",
              type: "line",
              stack: "总量",
              smooth: true,
              lineStyle: {
                width: 0
              },
              showSymbol: false,
              areaStyle: {
                opacity: 0.8,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: "rgba(128, 255, 165)"
                  },
                  {
                    offset: 1,
                    color: "rgba(1, 191, 236)"
                  }
                ])
              },
              emphasis: {
                focus: "series"
              },
              data: this.yLineDataOne
            },
            {
              name: "上月",
              type: "line",
              stack: "总量",
              smooth: true,
              lineStyle: {
                width: 0
              },
              showSymbol: false,
              areaStyle: {
                opacity: 0.8,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: "rgba(0, 221, 255)"
                  },
                  {
                    offset: 1,
                    color: "rgba(77, 119, 255)"
                  }
                ])
              },
              emphasis: {
                focus: "series"
              },
              data: this.yLineDataTwo
            }
          ]
        };
        getchart.setOption(option);
        //随着屏幕大小调节图表
        window.addEventListener("resize", () => {
          getchart.resize();
        });
      },
      getZwInfo24() {
        var _this = this;
        var libraryInfo = JSON.parse(sessionStorage.getItem("libraryInfo"))
        this.zwForm.ifcode = "10015";
        let params = new URLSearchParams();
        params.append("param", JSON.stringify(this.zwForm));
        getZwInfo(this.headerInfo.zwUrl, params).then(respone => {
          let list = JSON.parse(respone.datalist);
          if (list.length > 0) {
            list.find(function(item) {
              if (item.place == libraryInfo.zwAddress) {
                _this.totalcount  = item.tcount;
                return true;
              }
            });
          }
          
        });
      },
      getZwInfo31() {
        this.zwForm.ifcode = "10022";
        this.zwForm.lendstation = this.libraryInfo.borrowWorkNo;
        this.zwForm.username = this.libraryInfo.borrowOperator;
        let params = new URLSearchParams();
        params.append("param", JSON.stringify(this.zwForm));
        getZwInfo(this.headerInfo.zwUrl, params).then(respone => {
          this.zwInfo31 = respone;
          console.log("========================");
          console.log(this.zwInfo31);
          this.initData();
          this.initDataMain2();
        });
      }
    },
    destroyed() {
      clearInterval(this.timers);
    }
  };
</script>

<style scoped="scoped">
  .boxbing {
    background: url(../../static/shortBg.png) no-repeat;
    background-size: 100% 100%;
    width: 24.06%;
    height: 355px;
    overflow: hidden;
    margin-top: 20px;
    margin-left: 1%;
  }
  .boxBorder{
    width: 50%;
    height: 120px;
    float: left;
    margin-top: 20px;
  }
  .boxBorder p{
    text-align: center;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
  }
  .boxBorder span{
    background: url(../../static/border.png) no-repeat;
    width: 116px;
    background-size: cover;
    display: block;
    height: 105px;
    line-height: 65px;
    margin: 0 auto;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFED27;
  }
  .boxTwo {
    background: url(../../static/boxTwo.png) no-repeat;
    background-size: 100% 100%;
    width: 24.11%;
    min-height: 558px;
    overflow: hidden;
    margin-top: 20px;
    margin-left: 0.5%;
  }

  .boxThree {
    background: url(../../static/boxThree.png) no-repeat;
    background-size: 100% 100%;
    width: 24.11%;
    min-height: 558px;
    overflow: hidden;
    margin-top: 20px;
    margin-left: 0.5%;
  }

  .left {
    float: left;
  }

  .alltitle {
    margin-top: 12px;
    margin-left: 20px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    text-align: left;
  }

  .boxData {
    float: left;
    width: 100%;
    margin-top: 38px;
    margin-bottom: 38px;
  }

  .boxData p {
    float: left;
    text-align: center;
  }

  .boxData p:first-child {
    background: url(../../static/text1bg.png) no-repeat;
    background-size: 100% 100%;
    width: 173px;
    height: 54px;
    line-height: 54px;
    font-size: 20px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #15c5ff;
    margin-left: 8%;
  }

  .boxData p:last-child {
    background: url(../../static/text2bg.png) no-repeat;
    background-size: 100% 100%;
    width: 194px;
    height: 54px;
    line-height: 54px;
    font-size: 38px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #15c5ff;
    margin-left: 20px;
  }

  .operateMain {
    width: 100%;
    overflow: hidden;
  }

  .operateMain p {
    width: 100%;
    float: left;
    text-align: left;
    margin-left: 77px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    margin-top: 30px;
  }

  .operateMain p span {
    font-size: 40px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    margin-left: 20px;
  }

  .operateMain p:nth-child(1) span {
    color: #ffed27;
  }

  .operateMain p:nth-child(2) span {
    color: #27ff73;
  }

  .operateMain p:nth-child(3) span {
    color: #279cff;
  }

  .operateMain p:nth-child(4) span {
    color: #ff8227;
  }

  .operateMainTwo {
    width: 100%;
    overflow: hidden;
  }

  .operateMainTwo p {
    width: 100%;
    float: left;
    text-align: left;
    margin-left: 77px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    margin-top: 30px;
  }

  .operateMainTwo p span {
    font-size: 40px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    margin-left: 20px;
  }

  .operateMainTwo p:nth-child(1) span {
    color: #c75cff;
  }

  .operateMainTwo p:nth-child(2) span {
    color: #ffaf7f;
  }

  .operateMainTwo p:nth-child(3) span {
    color: #19ffcc;
  }

  .operateMainTwo p:nth-child(4) span {
    color: #19a6ff;
  }

  .right {
    float: right;
    margin-right: 1%;
  }

  .top20 {
    margin-top: 30px;
  }

  .minbox {
    width: 100%;
    overflow: hidden;
  }

  .echart {
    width: 50%;
    height: 170px;
    float: left;
  }

  .minboxData {
    float: left;
    margin-top: 10px;
  }

  .minboxData p {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    line-height: 60px;
  }

  .minboxData p span {
    font-size: 40px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #19a6ff;
    margin-left: 10px;
  }

  .contrastBox {
    background: url(../../static/contrastBg.png) no-repeat;
    background-size: 100% 100%;
    width: 48.33%;
    height: 355px;
    overflow: hidden;
    margin-top: 20px;
    margin-left: 1%;
    float: left;
  }

  .echartLine {
    width: 98%;
    height: 300px;
  }

  .QRcode {
    background: url(../../static/QRcodeBg.png) no-repeat;
    background-size: 100% 100%;
    width: calc(24.11% - 40px);
    float: right;
    margin-right: 1%;
    height: 355px;
    margin-top: 20px;
    display: flex;
    padding: 0 20px;
  }

  .qrcodeImg {
    width: 160px;
    height: 160px;
    display: block;
    margin: 20px auto 0;
    border: 6px solid #fac858;
  }

  .tip {
    width: 245px;
    height: 57px;
    font-size: 17px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fac858;
    line-height: 40px;
    margin: 30px auto 0;
  }
  .ring{
    margin-top: 60px;
  }
  .ringName{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #E6E6E6;
  }
  .ringnum{
    font-size: 36px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FAC858;
  }
  .ringnum span{
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/realTimes.vue